import { useEffect, useRef } from 'react';

const DEFAULT_TITLE = 'Phenom Poker';

export const useDocumentTitle = (title: string | null | undefined) => {
  const previousTitle = useRef(document.title);

  useEffect(() => {
    if (title && title !== previousTitle.current) {
      document.title = title;
      previousTitle.current = title;
    } else if (!title && document.title !== DEFAULT_TITLE) {
      document.title = DEFAULT_TITLE;
      previousTitle.current = DEFAULT_TITLE;
    }

    return () => {
      if (document.title !== DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
        previousTitle.current = DEFAULT_TITLE;
      }
    };
  }, [title]); // Always include the dependency array, even if it's empty
};
